import { createSlice } from '@reduxjs/toolkit'

export interface Pricelists {
  siteNumber?: string[]
}

export const siteSlice = createSlice({
  name: 'site',
  initialState: {
    sites: [] as string[],
    pricelists: {} as Pricelists,
    enabled: [] as number[],
    siteDataChanges: false as boolean,
  },
  reducers: {
    setSites: (state, action) => {
      state.sites = action.payload
    },
    setPricelists: (state, action) => {
      state.pricelists = action.payload
    },
    setEnabled: (state, action) => {
      state.enabled = action.payload
    },
    setChanges: (state, action) => {
      state.siteDataChanges = action.payload
    },
    updatePricelists: (state, action) => {
      const oldPricelistCopy = { ...state.pricelists }

      oldPricelistCopy[action.payload.site] = action.payload.value

      state.pricelists = oldPricelistCopy

      state.siteDataChanges = true
    },
    updateEnabled: (state, action) => {
      if (action.payload.value) {
        if (!state.enabled.find(x => x === action.payload.site)) state.enabled = [...state.enabled, action.payload.site]
      } else {
        state.enabled = state.enabled.filter(x => x !== action.payload.site)
      }

      state.siteDataChanges = true
    },
  },
})

// Action creators are generated for each case reducer function
export const { setSites, setPricelists, setEnabled, setChanges, updatePricelists, updateEnabled } = siteSlice.actions

export default siteSlice.reducer
